import { forwardRef } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export const GoldLineInput = forwardRef(({
    className = "",
    placeholder = "",
    value,
    onChange,
    type = "text",
    ...props
}, ref) => {
    return (
        <motion.div
            className="relative w-full"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
        >
            <input
                ref={ref}
                type={type}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className={cn(
                    "w-full bg-transparent",
                    "border-0 border-b border-primary/50",
                    "px-0 py-3",
                    "text-base text-center",
                    "placeholder:text-muted-foreground/60 placeholder:italic",
                    "font-cinzel tracking-wider",
                    "focus:outline-none focus:border-primary",
                    "transition-all duration-300",
                    className
                )}
                style={{
                    color: "#FFD700", // Bright gold for typed text
                    textShadow: value ? "0 0 10px rgba(255,215,0,0.3)" : "none"
                }}
                {...props}
            />
            {/* Animated underline glow */}
            <motion.div
                className="absolute bottom-0 left-1/2 h-[2px] bg-gradient-to-r from-transparent via-primary to-transparent"
                initial={{ width: 0, x: "-50%" }}
                animate={{ 
                    width: value ? "100%" : "0%",
                    opacity: value ? 1 : 0
                }}
                style={{ translateX: "-50%" }}
                transition={{ duration: 0.3 }}
            />
        </motion.div>
    );
});

GoldLineInput.displayName = "GoldLineInput";

export default GoldLineInput;
